jQuery(function($){

  $('html').removeClass('no-js'); 
  
  $('ul.styles > li').click(function(){
      var className = $(this).attr('class');
      $('body').removeClass('theme-style-0 theme-style-1 theme-style-2 theme-style-3');
      $('body').addClass(className);
    });

  $('li:last-child, .product-listing > div:last-child').addClass('lastItem');
  $('li:first-child, .product-listing > div:first-child').addClass('firstItem');
  

  /* Dropdown menu */
  $('ul.sf-menu').supersubs({
      minWidth:    12,   // minimum width of submenus in em units
      maxWidth:    27,   // maximum width of submenus in em units
      extraWidth:  1     // extra width can ensure lines don't sometimes turn over
                               // due to slight rounding differences and font-family
    }).superfish({
      animation: { height: 'show' }, // slide-down animation
      speed: 'fast' // faster animation speed
  });

  var ismobile = navigator.userAgent.match(/(iPhone)|(iPod)|(android)|(webOS)/i)
    if(ismobile){
      $('.sf-menu').sftouchscreen();
    }

  $( ".sub-category" ).parent().append( "<i class=\"fa-angle-down clickme\"></i>" );

  $( ".clickme" ).click(function() {
    //console.log($(this).parent("li").find(".sub-category").css("position"));
        if ($(this).parent("li").find(".sub-category").css("position") === "static" ){

          $(".sub-category").slideUp("medium", function(){});

          $(this).parent().find(".sub-category" ).slideToggle( "medium", function() {
            // Animation complete.
          });
        }
});
  
  $( ".clickme" ).parent("li").hover(function() {
    //clearTimeout(timer);
    //Variables.$obj = $(this);
    //setTimeout(function() {
    if ($(this).find(".sub-category").css("position") == "absolute" ){
    	$(".sub-category").slideUp("fast", function(){});
      //if ($("li:hover .sub-category").css("display") == "none") {
        $(this).find(".sub-category").slideDown( "fast", function() {
            // Animation complete.
        });
      //}
    }
    //}, 800)
}, function(){
        //clearTimeout(timer);
    //if ($(this).find(".sub-category").css("position") == "absolute" ){
          $(this).find(".sub-category" ).slideUp( "fast", function() {
          // Animation complete.
        });
      }
  	//}
);
  
  /*$( ".clickme" ).parent("li").mouseleave(function() {
      clearTimeout(timer);

      
});*/


  /* mobile menu */
  $("#mobile_menu").change(function(){ window.location = jQuery(this).val(); });


  /* custom selects 
  $('.jq-selectbox__trigger').append('<i class="fa fa-caret-down"></i>'); */


  /* Placeholder JS */
  /*==========================*/

  $('[placeholder]').each(function(){
    if ($(this).val() === '') {
      var hint = $(this).attr('placeholder');
      $(this).val(hint).addClass('hint');
    }
  });

  $('[placeholder]').focus(function() {
    if ($(this).val() === $(this).attr('placeholder')) {
      $(this).val('').removeClass('hint');
    }
  }).blur(function() {
    if ($(this).val() === '') {
      $(this).val($(this).attr('placeholder')).addClass('hint');
    }
  });                    

  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });

   
   /*Form styles*/  
  $('.address_table form, .customer_address form').addClass('form-horizontal');


  /* Alerts */
  $('.template-customers-login, #create_customer').find('.errors').addClass('alert').addClass('alert-danger');


  /* Stick menu */
  $(document).ready(function(){
  $('#navigation').tmStickUp({});
  })


/* scroll animation */
  var winwidth = $(window).width();
  if ($.browser.msie && $.browser.version == 8.0 || winwidth <= 1200) {
  }
  else {
      new WOW().init();
  };
  
  
  /* split words in logo */
  $.fn.splitWords = function(index) {
      return this.each(function() {
          var el = $(this),
              i, first, words = el.text().split(/\s/);
          if (typeof index === 'number') {
              i = (index > 0) ? index : words.length + index;
          }
          else {
              i = Math.floor(words.length / 2);
          }
          first = words.splice(0, i);
          el.empty().
              append(makeWrapElem(1, first)).
              append(makeWrapElem(2, words));
      });
  };
  function makeWrapElem(i, wordList) {
      return $('<span class="wrap-' + i + '">' + wordList.join('') + '</span>');
  }

  $('#logo a b').splitWords(1);  

  
  
  
  $('.column .widget ul.list li a').wrapInner('<span></span>');
});
